import {zodResolver} from '@hookform/resolvers/zod';
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@orbit-ui/components/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@orbit-ui/components/select';
import {cn} from '@orbit-ui/core';
import * as React from 'react';
import {useForm} from 'react-hook-form';
import {z} from 'zod';
import {useTheme} from '@/features/settings/hooks/useTheme';

const themeSettingsSchema = z.object({
  theme: z.string().min(1),
});

const ThemeSettingsForm = React.forwardRef<HTMLFormElement, React.HTMLProps<HTMLFormElement>>(
  ({className}, ref) => {
    const [theme, setTheme] = useTheme();

    const form = useForm({
      resolver: zodResolver(themeSettingsSchema),
      defaultValues: {
        theme,
      },
    });

    const handleThemeChange = (newTheme: typeof theme) => {
      setTheme(newTheme);
      form.setValue('theme', newTheme);
    };

    return (
      <Form {...form}>
        <form ref={ref} className={cn(`flex flex-col gap-8`, className)}>
          <FormField
            control={form.control}
            name="theme"
            render={({field}) => (
              <FormItem>
                <FormLabel>Interface Theme</FormLabel>
                <FormDescription>
                  The theme to use for the interface. Defaults to the system theme.
                </FormDescription>
                <FormControl>
                  <Select {...field} onValueChange={handleThemeChange}>
                    <SelectTrigger>
                      <SelectValue placeholder="Theme" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="system">System</SelectItem>
                      <SelectItem value="light">Light</SelectItem>
                      <SelectItem value="dark">Dark</SelectItem>
                    </SelectContent>
                  </Select>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </form>
      </Form>
    );
  },
);

ThemeSettingsForm.displayName = 'ThemeSettingsForm';

export {ThemeSettingsForm};
